import React from 'react';
import { Quote } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'PixelPerfect transformed our brand with a website that drives real business results.',
    name: 'Sarah Johnson',
    title: 'Horizon Finance'
  }, {
    quote: 'They went above and beyond, delivering a design that perfectly captures our essence.',
    name: 'Michael Chen',
    title: 'Bloom Beauty'
  }, {
    quote: 'User engagement increased by 45% after their redesign. Intuitive and impressive!',
    name: 'Emma Rodriguez',
    title: 'Pulse Health'
  }];
  return <section className="bg-black text-white border-b-2 border-black py-24" data-id="element-205">
      <div className="container mx-auto px-6" data-id="element-206">
        <div className="mb-16 border-b border-white/20 pb-8" data-id="element-207">
          <h2 className="text-4xl md:text-6xl font-heading font-black uppercase" data-id="element-208">
            Client
            <br data-id="element-209" />
            Feedback
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-210">
          {testimonials.map((testimonial, index) => <div key={index} className="flex flex-col justify-between h-full" data-id="element-211">
              <Quote size={48} className="text-swiss-red mb-6" data-id="element-212" />
              <p className="text-xl md:text-2xl font-medium leading-tight mb-8" data-id="element-213">
                "{testimonial.quote}"
              </p>
              <div data-id="element-214">
                <h4 className="font-bold uppercase tracking-wider text-swiss-red" data-id="element-215">
                  {testimonial.name}
                </h4>
                <p className="text-sm font-medium text-gray-400 uppercase" data-id="element-216">
                  {testimonial.title}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}